import MicrositeAxios from "@/config/microsite-service";
import router from "@/router";

const state = {
  campaign: null,
  user: null,
  history_code: null
};

const mutations = {
  SET_CAMPAIGN(state, payload) {
    state.campaign = payload.campaign;
  },
  SET_USER(state, payload) {
    state.user = payload.user;
  },
  CLEAR_USER_STATE(state) {
    state.user = null;
  },
  SET_HISTORY_CODE(state, payload) {
    state.history_code = payload.history_code;
  },
};

const getters = {
  getCampaign(state) {
    return state.campaign;
  },
  getUser(state) {
    return state.user;
  },
  getHistoryCode(state) {
    return state.history_code;
  }
};

const actions = {
  async getCampaign({ commit }, campaignSlug) {
    try {
      const siteId = this.state.defaultSystem.site.id;

      const response = await MicrositeAxios({
        method: "get",
        url: `getCampaign/${siteId}?slug=${campaignSlug}`
      });
      if (!response?.data?.data?.microsite) {
        router.push({
          name: "microsite-error",
          params: { slug: campaignSlug },
        });
        return
      }
      commit("SET_CAMPAIGN", {
        campaign: response.data.data.microsite
      });
    } catch (error) {
      console.log(error);
    }
  },
  async checkPhoneNumber({ commit }, { campaignId, phone }) {
    try {
      const response = await MicrositeAxios({
        method: "get",
        url: `checkPhoneNumber/${campaignId}?phone=${encodeURIComponent(phone)}`
      });
      const userExists = response?.data?.data?.users || null;
      if (userExists) {
        commit("microsite/SET_USER", {
          user: {
            phone: userExists.phone,
            fullname: userExists.fullname,
            line_id: userExists.line_id,
            detail: userExists.detail,
            history: userExists.CampaignTransaction,
            status_consent: userExists.status_consent,
          },
        }, { root: true });
        return userExists;
      }
      return null;
    } catch (error) {
      return null;
    }
  },
  async checkCampaignStatus() {
    const siteId = this.state?.defaultSystem?.site?.id;
    const campaignId = this.state?.microsite?.campaign?.id;
    try {
      const response = await MicrositeAxios({
        method: "get",
        url: `checkCampaignStatus/${siteId}?campaign=${campaignId}`
      });

      return response.data.data.status;
    } catch (error) {
      return 'error';

    }
  },
  async checkCampaignIsOngoing() {
    try {
      const siteId = this.state.defaultSystem.site.id;
      const campaignId = this.state.microsite.campaign.id;

      const response = await MicrositeAxios({
        method: "get",
        url: `checkCampaignIsOngoing/${siteId}?campaign=${campaignId}`
      });
      return response.data.data.isOngoing;
    } catch (error) {
      console.error(error);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
